import {
  SIGNUP_USER,
  SIGNUP_USER_SUCCESS,
  SIGNUP_USER_ERROR,
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  SIGNIN_USER_ERROR,
  OTP_USER,
  OTP_USER_SUCCESS,
  OTP_USER_ERROR,
  SIGNOUT_USER,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR
} from '../actions';

/* Signup */
export const signupUser = (user, history) => ({
  type: SIGNUP_USER,
  payload: { user, history }
})
export const signupUserSuccess = (user) => ({
  type: SIGNUP_USER_SUCCESS,
  payload: user
})
export const signupUserError = (message) => ({
  type: SIGNUP_USER_ERROR,
  payload: { message }
})

/* SIGNIN */
export const signinUser = (user, history) => ({
  type: SIGNIN_USER,
  payload: { user, history }
});
export const signinUserSuccess = (user) => ({
  type: SIGNIN_USER_SUCCESS,
  payload: user
});
export const signinUserError = (message) => ({
  type: SIGNIN_USER_ERROR,
  payload: { message }
});

/* OTP */
export const otpUser = (user, history) => ({
  type: OTP_USER,
  payload: { user, history }
});
export const otpUserSuccess = (user) => ({
  type: OTP_USER_SUCCESS,
  payload: user
});
export const otpUserError = (message) => ({
  type: OTP_USER_ERROR,
  payload: { message }
});

/* FORGOT */
export const forgotPassword = (forgotUserMail, history) => ({
  type: FORGOT_PASSWORD,
  payload: { forgotUserMail, history }
});
export const forgotPasswordSuccess = (forgotUserMail) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: forgotUserMail
});
export const forgotPasswordError = (message) => ({
  type: FORGOT_PASSWORD_ERROR,
  payload: { message }
});

/* RESET */
export const resetPassword = ({resetPasswordCode,newPassword,history}) => ({
  type: RESET_PASSWORD,
  payload: { resetPasswordCode,newPassword,history }
});
export const resetPasswordSuccess = (newPassword) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: newPassword
});
export const resetPasswordError = (message) => ({
  type: RESET_PASSWORD_ERROR,
  payload: { message }
});

/* SIGNOUT */
export const signoutUser = (history) => ({
  type: SIGNOUT_USER,
  payload: { history }
});